import { S3Client } from '@aws-sdk/client-s3'
import { Upload } from '@aws-sdk/lib-storage'
import { XhrHttpHandler } from '@aws-sdk/xhr-http-handler'
import { getWithAuthentication } from './http'

const gwApiUrl = process.env.REACT_APP_API_GW_BOOKING_API

export const getAWSCredentials = async () => {
  return getWithAuthentication(`${gwApiUrl}/booking-attachments-credentials`)
}

export const putObjectToS3 = (
  { aws_access_key_id, aws_secret_access_key, aws_session_token },
  params,
  setLoadingProgressPercentage,
) => {
  const client = new S3Client({
    region: 'eu-west-1',
    credentials: {
      accessKeyId: aws_access_key_id,
      secretAccessKey: aws_secret_access_key,
      sessionToken: aws_session_token,
    },
    requestHandler: new XhrHttpHandler({}),
  })
  const upload = new Upload({
    client,
    params,
  })
  upload.on('httpUploadProgress', (progress) => setLoadingProgressPercentage((100 * progress.loaded) / progress.total))

  return upload.done()
}
